import {version} from '../../package.json';

export const environment = {
  production: false,
  apiUrl: '/api',
  version
};
